// extracted by mini-css-extract-plugin
module.exports = {"title":"MileHistories_title__28BFU","notes":"MileHistories_notes__EzZND"};